/**
 * Todo Plugin for Vue
 * Provides a global $todo API for managing todos
 */

const TodoPlugin = {
    install(Vue) {
        // Create a Vue instance to act as an event bus
        const eventBus = new Vue();
        
        // Store the event bus on Vue prototype for the GlobalTodo component
        Vue.prototype.$todoBus = eventBus;
        
        // Create a global todo API
        Vue.prototype.$todo = {
            // Emit events to the GlobalTodo component
            refresh() {
                eventBus.$emit('todo:refresh');
            },
            
            complete(todo) {
                eventBus.$emit('todo:complete', todo);
            },
            
            restore(todo) {
                eventBus.$emit('todo:restore', todo);
            },
            
            // Show/hide the todo dropdown
            show() {
                eventBus.$emit('todo:show');
            },
            
            hide() {
                eventBus.$emit('todo:hide');
            },
            
            toggle() {
                eventBus.$emit('todo:toggle');
            }
        };
        
        // Also add to the root instance for backward compatibility
        Vue.mixin({
            beforeCreate() {
                if (this.$options.name === 'Root' || !this.$parent) {
                    this.$todo = Vue.prototype.$todo;
                }
            }
        });
    }
};

export default TodoPlugin;